import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import { createBalanceSheetDashboardData } from "../../graphql/mutations";
import { listdashboardbalances } from "../../graphql";

export const balanceSheetApi = createApi({
  reducerPath: "balanceSheet",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    fetchBalanceSheetData: builder.query({
      query: ({ StartDate, EndDate, OpeningBalance }) => ({
        body: createBalanceSheetDashboardData,
        variables: {
          StartDate,
          EndDate,
          OpeningBalance,
        },
      }),
      keepUnusedDataFor: Infinity,
      refetchOnMountOrArgChange: true,
      providesTags: ["BalanceSheetData"],
    }),
    fetchBalaneSheetledgerBalance: builder.query({
      query: ({ StartDate, EndDate, OpeningBalance,companyid }) => ({
        body: listdashboardbalances,
        variables: {
          startdate:StartDate,
          enddate:EndDate,
          openingbalance:OpeningBalance,
          companyid
        },
      }),
      keepUnusedDataFor: Infinity,
      refetchOnMountOrArgChange: true,
      providesTags: ["BalanceSheetLedgerBalance"],
    }),
  }),
});

export const {
  useFetchBalanceSheetDataQuery,
  useFetchBalaneSheetledgerBalanceQuery
} = balanceSheetApi;
